import React, { useEffect, useRef, useState } from 'react';
import { IDEA_FONTS, getIdeaFontFamily, getIdeaFontSize } from '../../config/nodeFonts';
import { getThemeDiscussionPalette, getThemeNodeFontFamily } from '../../config/themes';
import './NodeFontDialog.css';

export default function NodeFontDialog({ node, theme, isDarkMode, onApply, onClose }) {
  const dialog = useRef(null);
  const [font, setFont] = useState(node.fontFamily || 'theme');
  const [size, setSize] = useState(getIdeaFontSize(node.fontSize));
  const palette = getThemeDiscussionPalette(theme, isDarkMode);
  const valid = Number.isFinite(Number(size)) && Number(size) >= 8 && Number(size) <= 96;
  useEffect(() => {
    const previousFocus = document.activeElement;
    dialog.current.showModal();
    return () => previousFocus?.focus?.({ preventScroll: true });
  }, []);
  return <dialog ref={dialog} data-export-ignore="true" className="node-font-dialog" aria-labelledby="node-font-title"
    style={{ background: palette.panel, color: palette.text, borderColor: palette.border, fontFamily: getThemeNodeFontFamily(theme), '--font-input': palette.input, '--font-border': palette.border }}
    onCancel={event => { event.preventDefault(); onClose(); }}
    onPointerDown={event => event.stopPropagation()} onClick={event => event.stopPropagation()}
    onKeyDown={event => event.stopPropagation()}>
    <form onSubmit={event => { event.preventDefault(); if (valid) onApply({ fontFamily: font === 'theme' ? null : font, fontSize: Number(size) }); }}>
      <h2 id="node-font-title">Idea font</h2>
      <label htmlFor="idea-font-family">Font</label><select id="idea-font-family" autoFocus value={font} onChange={event => setFont(event.target.value)}>
        {IDEA_FONTS.map(option => <option key={option.id} value={option.id}>{option.name}</option>)}
      </select>
      <label htmlFor="idea-font-size">Font size</label><input id="idea-font-size" type="number" min="8" max="96" value={size} onChange={event => setSize(event.target.value)} />
      <div className="node-font-dialog__preview" aria-label="Font preview" style={{ fontFamily: getIdeaFontFamily(font, theme), fontSize: `${valid ? Number(size) : 14}px` }}>{node.text || 'Your idea'}</div>
      <p>New children will use this font and size.</p>
      <div className="node-font-dialog__actions">
        <button type="button" onClick={onClose}>Cancel</button>
        <button type="submit" disabled={!valid}>Apply font</button>
      </div>
    </form>
  </dialog>;
}
